import { render, staticRenderFns } from "./passReset.vue?vue&type=template&id=5564cef7&scoped=true&"
import script from "./passReset.vue?vue&type=script&lang=js&"
export * from "./passReset.vue?vue&type=script&lang=js&"
import style0 from "./passReset.vue?vue&type=style&index=0&id=5564cef7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564cef7",
  null
  
)

export default component.exports